import { SetRecorder } from "./recorder";

let _mediaStream: MediaStream | null = null;

/** Clear the stored stream so the next recording session gets a fresh device. Call when recording stops. */
export function clearMediaStream() {
  if (_mediaStream) {
    console.log(' [HANDLER] clearMediaStream() - releasing stored stream reference');
    _mediaStream.getTracks().forEach((track) => track.stop());
    _mediaStream = null;
  }
}

/** Log microphone permission state (e.g. from Flutter WebView) for debugging */
function logMicPermissionState() {
  // console.log('🔐 [HANDLER] ========== MIC PERMISSION CHECK (Flutter/WebView) ==========');
  // console.log('🔐 [HANDLER] navigator.mediaDevices exists:', !!navigator.mediaDevices);
  // console.log('🔐 [HANDLER] navigator.permissions exists:', !!navigator.permissions);
  // console.log('🔐 [HANDLER] Platform:', window.navigator.platform);
  // console.log('🔐 [HANDLER] User Agent:', window.navigator.userAgent);

  if (navigator.permissions && navigator.permissions.query) {
    const permissionName = 'microphone' as PermissionName;
    navigator.permissions.query({ name: permissionName })
      .then((result) => {
        // console.log('🔐 [HANDLER] Permissions API - microphone state:', result.state);
        // console.log('🔐 [HANDLER] If "granted" = Flutter/WebView has allowed mic. If "denied" or "prompt" = check native permission.');
      })
      .catch((err) => {
        // console.log('🔐 [HANDLER] Permissions API not supported or error:', err?.message || err);
        // console.log('🔐 [HANDLER] (Safari/iOS often does not support permissions.query - getUserMedia will show actual result)');
      });
  } else {
    // console.log('🔐 [HANDLER] Permissions API not available - will rely on getUserMedia result');
  }
  // console.log('🔐 [HANDLER] ========== END MIC PERMISSION CHECK ==========');
}

export async function startRecording(setRecorderState: SetRecorder) {
  // console.log('🎙️ [HANDLER] startRecording called');
  // console.log('🎙️ [HANDLER] Platform:', window.navigator.platform);
  // console.log('🎙️ [HANDLER] User Agent:', window.navigator.userAgent);

  // Log permission state before requesting (to verify Flutter/WebView granted permission)
  logMicPermissionState();
  //  _mediaStream = null;
  console.log('🎙️ [HANDLER] Cleared previous media stream reference before getUserMedia. _mediaStream is now:', _mediaStream);
  try {
    // CRITICAL: Clean up previous media stream so second mic (options / sub-options) can capture
    const hadPreviousStream = !!_mediaStream;
    if (_mediaStream) {
      // console.log('🧹 [HANDLER] Cleaning up previous media stream (main mic or first options mic)...');
      _mediaStream.getTracks().forEach(track => {
        // console.log('🛑 [HANDLER] Stopping track:', track.label);
        track.stop();
      });
      _mediaStream = null;
      // On iOS, give the device time to release before requesting again (fixes "second mic not capturing")
      const isIOS = /iPhone|iPad|iPod|Mac/i.test(navigator.platform);
      if (isIOS && _mediaStream) {
        const delayMs = 600;
        console.log(`🍎 [HANDLER] iOS: waiting ${delayMs}ms after releasing previous stream before getUserMedia`);
        await new Promise((r) => setTimeout(r, delayMs));
        // console.log('🍎 [HANDLER] iOS delay complete, requesting mic');
      }
    }

    // console.log('🎙️ [HANDLER] Requesting microphone via getUserMedia({ audio: true })...');
    // console.log('🎙️ [HANDLER] If Flutter/WebView granted mic permission, this should succeed.');
    const stream: MediaStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
    });

    // console.log('✅ [HANDLER] Microphone permission GRANTED (Flutter/WebView allowed access)');
    // console.log('🎙️ [HANDLER] Stream tracks:', stream.getTracks().length);
    stream.getTracks().forEach((track, index) => {
      console.log(`🎙️ [HANDLER] Track ${index}:`, {
        kind: track.kind,
        label: track.label,
        enabled: track.enabled,
        muted: track.muted,
        readyState: track.readyState
      });
    });

    _mediaStream = stream;
   // console.log('✅ [HANDLER] Media stream stored in module variable');

    setRecorderState((prevState) => {
      // console.log('🎙️ [HANDLER] Setting recorder state with new stream');
      return {
        ...prevState,
        initRecording: true,
        mediaStream: stream,
      };
    });
  } catch (err: any) {
    console.error('❌ [HANDLER] ========== MIC PERMISSION / ACCESS FAILED ==========');
    console.error('❌ [HANDLER] Error starting recording:', err);
    console.error('❌ [HANDLER] Error name:', err?.name);
    console.error('❌ [HANDLER] Error message:', err?.message);
    console.error('❌ [HANDLER] Error code:', (err as any)?.code);
    if (err?.name === 'NotAllowedError' || err?.name === 'PermissionDeniedError') {
      // console.error('❌ [HANDLER] → User or Flutter/WebView DENIED microphone permission. Check native app permission settings.');
    } else if (err?.name === 'NotFoundError') {
      // console.error('❌ [HANDLER] → No microphone found on device.');
    } else if (err?.name === 'NotReadableError' || err?.name === 'TrackStartError') {
      // console.error('❌ [HANDLER] → Microphone in use by another app or not released by previous session.');
    }
    // console.error('❌ [HANDLER] ========== END MIC ERROR ==========');
  }
}

export function saveRecording(recorder: any) {
  // console.log('💾 [HANDLER] saveRecording called');
  // console.log('💾 [HANDLER] Recorder exists:', !!recorder);
  // console.log('💾 [HANDLER] Recorder state:', recorder?.state);

  if (recorder && recorder.state !== "inactive") {
    // console.log('⏹️ [HANDLER] Stopping recorder (state was:', recorder.state, ')');
    recorder.stop();
    // console.log('⏹️ [HANDLER] Recorder.stop() called');
  } else {
    // console.log('⚠️ [HANDLER] Cannot stop - Recorder is null or already inactive');
    if (!recorder) {
      // console.log('⚠️ [HANDLER] Recorder is null/undefined');
    } else {
      // console.log('⚠️ [HANDLER] Recorder state is already inactive');
    }
  }
}
